module.exports = __webpack_public_path__ + "images/1-hover090434e828dded1cfe9607e721ff3276.svg";